import { Component, OnInit, KeyValueDiffers, DoCheck, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { BoardService } from "./board.service";
import { Router } from "@angular/router";

declare var $;

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.css'],
  providers: [
    BoardService
  ]
})
export class BoardComponent implements OnInit {

  title: string;

  isLoading: boolean;
  filterParams: any;
  totalPage: number;
  boardList: any;
  boardInfo: any;
  totalElements: number;

  //watch variable change
  differ: any;
  constructor(
    private boardService: BoardService,
    private differs: KeyValueDiffers,
    private toastr: ToastsManager,
    private vcr: ViewContainerRef,
    private router: Router
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.differ = this.differs.find({}).create();
  }

  ngOnInit() {
    this.title = "board";
    this.filterParams = {
      size: 10,
      page: 0,
      sortNew: true
    };
  }

  ngDoCheck() {
    var change = this.differ.diff(this.filterParams);
    if (change) {
      if (this.filterParams.page < 0) {
        this.filterParams.page = 0;
        return;
      } else if (this.filterParams.page > this.totalPage - 1) {
        this.filterParams.page = this.totalPage - 1;
        return;
      }
      this.getboardList();
    }
  }

  getboardList() {
    if (this.isLoading) {
      return;
    }

    this.isLoading = true;
    this.boardService.getBoardList(this.filterParams)
      .then(res => {
        if( res.status === 1 )
        {
          this.boardList = res.data.dataList;
          this.totalElements = res.data.totalElements;
          this.initPaginate();
          this.isLoading = false;
        } else {
          this.toastr.error(res.message , 'Error!');
          if (res.errorCode === 3000) {
            localStorage.setItem("alert", JSON.stringify(res.message));
            this.router.navigate(['login']);
          }
        }
        
      })
      .catch(err => console.log(err));
  }

  //init paging 
  initPaginate() {
    this.totalPage = Math.ceil(this.totalElements / this.filterParams.size);
    let arrPagingNumber = [];
    for (let i = 0; i < this.totalPage; i++) {
      arrPagingNumber.push(i);
    }
    return arrPagingNumber;
  }

  showDevice(board: any){
    this.boardInfo = board;
    $('#myModal').modal('show');
  }

  sortLastOnline() {
    this.filterParams.sortNew = !this.filterParams.sortNew;
    this.getboardList();
  }
}



// WEBPACK FOOTER //
// /build/client-cms/src/app/board/board.component.ts